import { useEffect, useState } from 'react';

/*
    Hook to get range data from algolia for a min and a max attribute

    Example:
    const minRangeSlider = useRangeSlider( { attribute: 'min_bedrooms', step: 1 } );
	const maxRangeSlider = useRangeSlider( { attribute: 'max_bedrooms', step: 1 } );
	const { isReady, ranges, options } = useRangeSliderData( { minRangeSlider, maxRangeSlider } );
*/
const useRangeSliderData = ( props ) => {
	const { minRangeSlider, maxRangeSlider } = props;
	const [ minRange, setMinRange ] = useState( [] );
	const [ maxRange, setMaxRange ] = useState( [] );
	const [ ranges, setRanges ] = useState( { min: [], max: [] } );
	const [ isInitialRangesSet, setIsInitialRangesSet ] = useState( false );
	const [ isReady, setIsReady ] = useState( false );

	// update min
	useEffect( () => {
		if ( ! isInitialRangesSet && ( minRangeSlider.range.min.length === 0 || minRangeSlider.range.min === 0 ) ) {
			return;
		}
		const minLength = minRangeSlider.range.max + 1 - minRangeSlider.range.min;
		// round down to nearest whole number because options are in whole numbers (although ranges could be in decimals, e.g. 2.5 bathrooms)
		const newMinRange = Array.from( { length: minLength }, ( v, k ) => k + Math.floor( minRangeSlider.range.min ) );
		// console.log( 'Setting min', minRangeSlider.range.min, newMinRange );
		setMinRange( newMinRange );
	}, [ minRangeSlider.range ] );

	// update max
	useEffect( () => {
		if ( ! isInitialRangesSet && ( maxRangeSlider.range.max.length === 0 || maxRangeSlider.range.max === 0 ) ) {
			return;
		}
		const maxLength = maxRangeSlider.range.max + 1 - maxRangeSlider.range.min;
		// round down to nearest whole number because options are in whole numbers (although ranges could be in decimals, e.g. 2.5 bathrooms)
		const newMaxRange = Array.from( { length: maxLength }, ( v, k ) => k + Math.floor( maxRangeSlider.range.min ) );
		// console.log( 'Setting max', maxRangeSlider.range.max, newMaxRange );
		setMaxRange( newMaxRange );
	}, [ maxRangeSlider.range ] );

	// update ranges
	useEffect( () => {
		if ( minRange.length === 0 || minRange[ 0 ] === 0 || maxRange.length === 0 || maxRange[ 0 ] === 0 ) {
			return;
		}
		// console.log( 'updating ranges', minRange, maxRange );
		// const maxRangeWithoutOverlap = maxRange.filter( ( item ) => ! minRange.includes( item ) );
		setRanges( { min: minRange, max: maxRange } );
		setIsInitialRangesSet( true );
	}, [ minRange, maxRange ] );

	useEffect( () => {
		if ( ! isInitialRangesSet ) {
			return;
		}
		if ( ! isReady ) {
			setIsReady( true );
		}
	}, [ isInitialRangesSet, ranges, isReady ] );
	return { ranges, isReady };
};

export default useRangeSliderData;
